import styled from 'styled-components';
import { breakpoints } from "../../commons/breakpoints";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";

const Button = styled(Link)`
  display: inline-block;
  width: calc(100% - 32px);
  padding: 16px;
  color: ${props => props.theme.colors.white};
  font-size: 13px;
  line-height: 13px;
  font-family: 'NouvelRBold';
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  background-color: ${props => props.theme.colors.black};
  border: 1px solid ${props => props.theme.colors.black};
  vertical-align: middle;
  transition: background-color 0.5s ease 0s, color 0.5s ease 0s, border-color 0.5s ease 0s, color 0.5s ease 0s;
  cursor: pointer;
  
  @media ${breakpoints.sm} {
    width: 90%;
    font-size: 14px;
    line-height: 14px;
  }
  
  &:hover {
    color: ${props => props.theme.colors.black};
    background-color: ${props => props.theme.colors.brandColor};
    border-color: ${props => props.theme.colors.brandColor};
  }
`;

const ButtonPrimary = ({text, destination, callback}) => {
  return (
      <Button className="button button--primary" to={destination} onClick={callback}>{text}</Button>
  );
};

ButtonPrimary.propTypes = {
  text: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
  callback: PropTypes.func,
};

export default ButtonPrimary;
